import {Component, EventEmitter, Input, Output} from '@angular/core';
import Article from "../../../smoothr-web-app-core/models/Article";
import ArticleGroup from "../../../smoothr-web-app-core/models/ArticleGroup";
import {
  defaultsToArticleOption,
  getBasePrice,
  numberD,
  numberToCurrency
} from "../../../smoothr-web-app-core/utils/utils";
import {OrderType} from "../../../smoothr-web-app-core/enums/OrderType";
import {OrderUtils} from "../../../smoothr-web-app-core/utils/order-utils";
import {ValidationUtils} from "../../../smoothr-web-app-core/utils/validation-utils";
import OptionGroup from "../../../smoothr-web-app-core/models/OptionGroup";
import Order from "../../../smoothr-web-app-core/models/Order";

@Component({
  selector: 'app-recommendation-article',
  templateUrl: './recommendation-article.component.html',
  styleUrl: './recommendation-article.component.scss'
})
export class RecommendationArticleComponent {
  @Input() article: Article;
  @Input() selectedArticles: { article: Article, quantity: number }[] = [];
  @Input() order: Order

  @Output() selectArticle: EventEmitter<Article> = new EventEmitter();
  @Output() decreaseQuantity: EventEmitter<Article> = new EventEmitter();
  @Output() increaseQuantity: EventEmitter<Article> = new EventEmitter();

  showAmount(article: Article) {
    return this.selectedArticles.find(it => it.article._id == article._id)?.quantity ??
        this.order.orderedArticles.find(it => it.article._id == article._id)?.quantity ?? 0;
  }



  private minOfItem<T>(items: T[], transformer: (item: T) => number): T {
    if (items.length === 1) {
      return items[0];
    }
    const values = items.map(item => transformer(item));
    const min = Math.min(...values);
    const index = values.indexOf(min);
    return items[index];
  }
  reloadPriceNew(articleValue: Article) {
    const articleGroup = new ArticleGroup();
    articleGroup.article = articleValue;
    articleGroup.groups = defaultsToArticleOption(articleValue, [], [], OrderType.PREORDER, this.order.preorder.type);
    articleGroup.quantity = 1;
    const article = JSON.parse(JSON.stringify(articleGroup.article)) as Article;
    let price = OrderUtils.totalPrice(articleGroup, this.order?.type, this.order.preorder.type);

    const processedGroups: string[] = [];

    article.groups.forEach(grp => {
      if (processedGroups.indexOf(grp._id) >= 0) return;
      if (ValidationUtils.isGroupDependencyFulfilled(articleGroup.article, articleGroup.groups, grp).times < 0) return;
      if (grp.requiredAmount == grp.limit) {
        const minimumItem = this.minOfItem(grp.articles, opt => numberD(opt.price));

        price += numberD(minimumItem.price) * grp.requiredAmount;
        processedGroups.push(grp._id);
      }
    });
    const tagPrice = this.findTagPrice(articleValue);
    let finalPrice = price - tagPrice;

    return numberToCurrency(finalPrice, this.order.currency)
  }
  reloadPrice(articleValue: Article) {
    const articleGroup = new ArticleGroup();
    articleGroup.article = articleValue;
    articleGroup.groups = defaultsToArticleOption(articleValue, [], [], OrderType.PREORDER, this.order.preorder.type);

    articleGroup.quantity = 1;

    const article = articleGroup.article;
    let price = numberD(article.price);
    const processedGroups: string[] = [];
    article.groups.forEach(grp => {
      if (processedGroups.indexOf(grp._id) >= 0) return;
      if (ValidationUtils.isGroupDependencyFulfilled(articleGroup.article, articleGroup.groups, grp).times < 0) return;
      if (grp.requiredAmount == grp.limit) {
        const minimumItem = this.minOfItem(grp.articles, opt => numberD(opt.price));

        price += numberD(minimumItem.price) * grp.requiredAmount;
        const dependants = this.dependenciesRegardingOptionArticle(article, article.groups, minimumItem);
        dependants.forEach(dependant => {
          const dependantMinimumItem = this.minOfItem(dependant.articles, opt => numberD(opt.price));
          price += grp.requiredAmount * dependant.requiredAmount * numberD(dependantMinimumItem.price);
          processedGroups.push(dependant._id);
        });
        processedGroups.push(grp._id);
      }
    });

    return numberToCurrency(price, this.order.currency);
  }
  dependenciesRegardingOptionArticle(article: Article, groups: OptionGroup[], optionArticle: Article): OptionGroup[] {
    return article.groupDependencies
        .map(gd => {
          if (gd.dependencies.find(dependeci => dependeci.groupArticles.includes(optionArticle._id)) == null) {
            return null;
          } else {
            return groups.find(it => gd.group === it._id);
          }
        })
        .filter(it => !!it);
  }

  checkMeasurmentPlusPfand(article: Article) {
    // let result = '';
    //
    // const pfandValue = this.checkPfandTag(article);
    // if (pfandValue) {
    //   result =
    //       this.translate.instant('pfand_text.zzgl') +
    //       (pfandValue === 'deposit15' ? numberToCurrency(0.15, this.order.currency) : numberToCurrency(0.25, this.order.currency)) +
    //       this.translate.instant('pfand_text.pfand') +
    //       '<br/>';
    // } else {
    //   if (result.length > 0) {
    //     result = result + ')';
    //   }
    // }
    // if (article?.measurement && article?.measurement?.unit && article?.measurement?.amount) {
    //   result =
    //       result +
    //       ' ' +
    //       article.measurement?.refAmount +
    //       ' ' +
    //       article.measurement?.refUnit +
    //       ' = ' +
    //       this.numberToCurrency(getBasePrice(article, OrderType.PREORDER, this.order.preorder.type), this.order.currency);
    // }
    // return result;
  }
  checkPfandTag(article: Article) {
    if (article.tags?.length === 0) {
      return '';
    }
    const deposit25 = article.tags.find(it => it.identifier === 'deposit25') ? 'deposit25' : '';
    const deposit15 = article.tags.find(it => it.identifier === 'deposit15') ? 'deposit15' : '';

    return deposit15 || deposit25;
  }
  isFromPrice(article: Article) {
    return !!article.tags.find(tag => tag.identifier === 'fromPrice');
  }


  findTagPrice(article: Article) {
    if (article && article.tags && article.tags.length > 0 && article.tags.find(it => it.identifier.includes('deposit'))) {
      const foundTag = article?.tags?.find(
          it =>
              it?.identifier === 'deposit25' ||
              it?.identifier === 'deposit15' ||
              it?.identifier === 'deposit08' ||
              it?.identifier === 'deposit28'
      );
      if (foundTag) {
        if (foundTag.identifier === 'deposit25') {
          return 0.25;
        }
        if (foundTag.identifier === 'deposit15') {
          return 0.15;
        }
        if (foundTag.identifier === 'deposit08') {
          return 0.08;
        }
        if (foundTag.identifier === 'deposit28') {
          return 0.28;
        }
        return 0;
      }
      return null;
    } else if (article?.deposit) {
      return numberD(article.deposit);
    } else {
      return null;
    }
  }

}
